/**
 * Reseller-admin overview route — eager half (CLA-907).
 *
 * Registers the file route only; the component and all atom / RPC / design
 * imports are deferred to `index.lazy.tsx` so the reseller-detail admin chunk
 * never lands in the always-loaded `main` bundle. The admin gate is inherited
 * from the `admin_/resellers` layout route's `beforeLoad` — this route adds none
 * of its own.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/resellers/$customerId/")({});
